import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { COMPANY } from "@/lib/company";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-slate-300">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 grid place-items-center bg-[#0052FF] text-white font-display font-bold">
              H
            </div>
            <div>
              <div className="font-display text-lg font-bold text-white">{COMPANY.name}</div>
              <div className="text-[10px] uppercase tracking-widerest text-slate-500 font-mono-plex">
                IT Training & Consultancy
              </div>
            </div>
          </div>
          <p className="mt-6 text-slate-400 text-sm leading-relaxed max-w-md">
            {COMPANY.tagline}
          </p>
          <p className="mt-3 text-xs text-slate-500 font-mono-plex uppercase tracking-widerest">
            {COMPANY.yearsInBusiness} years in the consulting / training business
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widerest text-slate-500 font-mono-plex mb-4">Navigate</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-white transition-colors" to="/">Home</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/about">About</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/courses">Courses</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/pay-demo">Book a Demo</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/blog">Blog</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widerest text-slate-500 font-mono-plex mb-4">Reach us</div>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-2"><MapPin className="w-4 h-4 mt-0.5 shrink-0 text-slate-500" /><span>{COMPANY.address}</span></li>
            <li className="flex gap-2"><Phone className="w-4 h-4 mt-0.5 shrink-0 text-slate-500" /><a href={`tel:${COMPANY.phoneDialable}`} className="hover:text-white">{COMPANY.phone}</a></li>
            <li className="flex gap-2"><Mail className="w-4 h-4 mt-0.5 shrink-0 text-slate-500" /><a href={`mailto:${COMPANY.email}`} className="hover:text-white break-all">{COMPANY.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</div>
          <div className="font-mono-plex uppercase tracking-widerest">Certified curriculum • PMP · ITIL · Salesforce · AWS</div>
        </div>
      </div>
    </footer>
  );
}
